import { render } from "./Example.vue?vue&type=template&id=784c4e1e&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"

import "./Example.vue?vue&type=style&index=0&id=784c4e1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-784c4e1e"

export default script